import _ from 'lodash';
window._ = _;


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Global interceptor to display restriction alerts when API indicates access is blocked
import { toast } from 'vue3-toastify';
import Swal from 'sweetalert2';

let __lastRestrictedNoticeAt = 0;
const RESTRICTED_TOAST_COOLDOWN_MS = 4000;

function showRestrictedNotice(message) {
    const now = Date.now();
    if (now - __lastRestrictedNoticeAt < RESTRICTED_TOAST_COOLDOWN_MS) return;
    __lastRestrictedNoticeAt = now;

    const text = message || 'Your account is restricted. Please upgrade to continue.';
    try {
        // Prefer showing our in-app SubscriptionRestrictionOverlay via a global event
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
            window.dispatchEvent(new CustomEvent('subscription:restricted', { detail: { message: text } }));
            return;
        }
        // Fallbacks if no listener exists
        if (toast && typeof toast.warn === 'function') {
            toast.warn(text, { autoClose: 5000 });
            return;
        }
    } catch (_) { /* fallthrough to alert */ }
    if (typeof window !== 'undefined' && window.alert) {
        window.alert(text);
    }
}

axios.interceptors.response.use(
    function (response) {
        try {
            const data = response && response.data;
            const restricted = data && (data.restricted === true || (data.data && data.data.restricted === true));
            if (restricted) {
                const msg = (data && data.message) || (data && data.data && data.data.message);
                showRestrictedNotice(msg);
            }
        } catch (_) { /* no-op */ }
        return response;
    },
    function (error) {
        try {
            const data = error && error.response && error.response.data;
            const restricted = data && (data.restricted === true || (data.data && data.data.restricted === true));
            if (restricted) {
                const msg = (data && data.message) || (data && data.data && data.data.message);
                showRestrictedNotice(msg);
            }
        } catch (_) { /* no-op */ }
        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
